// extracted by mini-css-extract-plugin
module.exports = {"arrow":"styles_arrow__1z4Kq","prev":"styles_prev__LT05z","next":"styles_next__2RtxL"};